import {ErrorCode} from "./error-code";

export class ErrorModel {

  public errorCode: ErrorCode;
  public message: string;

  constructor(errorCode: ErrorCode, message: string) {
    this.errorCode = errorCode;
    this.message = message;
  }
}
